// Extracts the plain item name from a string that may contain an anchor tag.
// If an anchor tag is present, returns its inner text; otherwise, strips any trailing </a> and returns the rest.
export function getPlainName(str) {
  const anchorMatch = str.match(/<a[^>]*>(.*?)<\/a>/);
  return anchorMatch ? anchorMatch[1] : str.split("</a>")[0];
}

// Appends HTML details to the item name for display in the inventory table.
// Adds an anchor tag for item details and a faded span for unit quantity and pack size.
// Only shows pack size if it is not 1 and not empty.
export function appendDetailsToItemName(item, index) {
  item.itemName = `<a href="#" id="linkItemDetails${index}">${item.itemName}</a>`;
  // Only add details if either unitQty or packSize is present
  if (item.unitQty !== '' || item.packSize !== '') {
    item.itemName += `<span class="opacity-50">`;
    // Add unit quantity if present
    if (item.unitQty !== '') item.itemName += ` ${item.unitQty}`;
    // Add pack size if present and not equal to 1
    if (item.packSize !== '' && item.packSize !== 1) item.itemName += ` ${item.packSize}pk`;
    item.itemName += `</span>`;
  }
}

// Returns a generic input change handler for forms.
// Updates the state for a form field based on the input's name and value.
export function handleInputChange(setState) {
  return (e) => {
    const { name, value } = e.target;
    setState(prev => ({ ...prev, [name]: value }));
  };
}

// Handles adding a new item to the inventory and resetting form/modal state.
// - Appends details to the item name for display
// - Adds the new item to the inventory array
// - Resets the new item form fields
// - Closes all transaction modals
export function handleAddNewItem({
  newItem,
  setInventory,
  setNewItemDetails,
  setShowTransactionReceiveModal,
  setShowTransactionReleaseModal,
  setShowTransactionOtherModal,
  appendDetailsToItemName,
  inventoryLength
}) {
  appendDetailsToItemName(newItem, inventoryLength);
  setInventory(prev => [...prev, newItem]);
  setNewItemDetails({
    name: '', category: '', price: '', unit: '', pack: '',
    item_id: '', quantity: '', org_id: '', value: ''
  });
  setShowTransactionReceiveModal(false);
  setShowTransactionReleaseModal(false);
  setShowTransactionOtherModal(false);
}
